module.exports = __webpack_public_path__ + "static/media/Toolbar.68bc2f47.svg";